import { getApiClient } from '../client';
import type { 
    KnowledgeBase, 
    KnowledgeSummary, 
    JsonPatchOperation,
    UUID 
} from '@dopomogai/types';
import { handleApiError } from '../utils/handleApiError';
import { ServiceResponse } from '@dopomogai/types';

// Functions are now defined as non-exported constants
const getKb = (kbId: UUID): ServiceResponse<KnowledgeBase> => {
  return getApiClient().get(`/api/v1/knowledge/bases/${kbId}`)
    .then(res => res.data)
    .catch(err => handleApiError(err, `fetching KB '${kbId}'`));
};

const listKbs = (): ServiceResponse<KnowledgeSummary[]> => {
  return getApiClient().get(`/api/v1/knowledge/bases`)
    .then(res => res.data)
    .catch(err => handleApiError(err, 'listing KBs'));
};

// For clarity, define the create payload type
type KnowledgeBaseCreate = Omit<KnowledgeBase, '_id' | 'user_id' | 'created_at' | 'updated_at'>;

const createKb = (payload: KnowledgeBaseCreate): ServiceResponse<KnowledgeBase> => {
  return getApiClient().post(`/api/v1/knowledge/bases`, payload)
    .then(res => res.data)
    .catch(err => handleApiError(err, 'creating KB'));
};

const updateKb = (kbId: UUID, patchOps: JsonPatchOperation[]): ServiceResponse<KnowledgeBase> => {
  return getApiClient().patch(`/api/v1/knowledge/bases/${kbId}`, patchOps)
    .then(res => res.data)
    .catch(err => handleApiError(err, `updating KB '${kbId}'`));
};

const deleteKb = (kbId: UUID): ServiceResponse<void> => {
  return getApiClient().delete(`/api/v1/knowledge/bases/${kbId}`)
    .then(res => res.data)
    .catch(err => handleApiError(err, `deleting KB '${kbId}'`));
};


// Export a single object containing all the service's functions
export const knowledgeService = {
    getKb,
    listKbs,
    createKb,
    updateKb,
    deleteKb,
};